import state from './moduleRegionState.js'
import mutations from './moduleRegionMutations.js'
import actions from './moduleRegionActions.js'
import getters from './moduleRegionGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
